import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { auditBaseUrl, prjectMgm } from '../endpoints';
// Define a service using a base URL and expected endpoints
  export const departmentMasterService = createApi({
    reducerPath: 'departmentMasterService',
    baseQuery: fetchBaseQuery({ baseUrl: auditBaseUrl }),
    tagTypes: ['DepartmentMaster'],
    endpoints: (builder) => ({
        getAllDepartmentMaster: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.departmentMasterController.getAllDepartmentMaster}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}`},
                }
            }
        }),
        getDepartmentMasterById: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.departmentMasterController.getDepartmentMasterById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}`},
                }
            }
        }),
        saveDepartmentMaster: builder.mutation({
            query(body){
                return {
                    url: `${prjectMgm.departmentMasterController.saveDepartmentMaster}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}`},
                    body: body.payload,
                }
            }
        }),
        updateDepartmentMaster: builder.mutation({
            query(body){
                return {
                    url: `${prjectMgm.departmentMasterController.updateDepartmentMaster}/${body.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}`},
                    body: body.payload,
                }
            }
        }),
        deleteDepartmentMaster: builder.mutation({
            query(body){
                return {
                    url: `${prjectMgm.departmentMasterController.deleteDepartmentMaster}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}`},
                }
            }
        }),
        getAllDepartmentMasterWithSearch: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.departmentMasterController.getAllDepartmentMasterWithSearch}`,
                    method: "POST",
                    headers: { Authorization: `Bearer ${body.token}`},
                    body: body.payload,
                };
            },
        }),
        findAllDepartmentMaster: builder.mutation({
            query(body) {
                return {
                    url: `${prjectMgm.departmentMasterController.findAllDepartmentMaster}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}`},
                }
            }
        }),
    })
  });
  export const {
    useGetAllDepartmentMasterMutation,
    useSaveDepartmentMasterMutation,
    useUpdateDepartmentMasterMutation,
    useDeleteDepartmentMasterMutation,
    useGetDepartmentMasterByIdMutation,
    useGetAllDepartmentMasterWithSearchMutation,
    useFindAllDepartmentMasterMutation,
  } = departmentMasterService;